class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#CartDrawer-Overlay');

    overlay.addEventListener('click', (evt) => {
      if (evt.target === overlay) {
        this.close();
      }
    });
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );


    /* lock scroll position */
    this._scrollY = window.scrollY;
    // document.body.style.position = 'fixed';
    /* compensate for missing scrollbar so content doesn't shift */
    const scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
    if (scrollBarGap > 0) document.body.style.paddingRight = `${scrollBarGap}px`;
    document.body.style.top = `-${this._scrollY}px`;

    document.body.classList.add('overflow-hidden');
    const email = this.dataset.customerEmail;

    if (email && !this.classList.contains('loyalty-loaded')) {
      fetchLoyaltyPoints(email)
          .then((points) => {
            showLoyaltyPoints(points, '.drawer__loyalty', '.drawer__loyalty-points');
            this.classList.add('loyalty-loaded');
          });
    }
  }

  close() {
    this.classList.remove('active');
    /* unlock scroll and restore previous position */
    const savedY = this._scrollY || 0;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.paddingRight = '';

    /* wait one frame so the browser applies new layout, then scroll back */
    requestAnimationFrame(() => window.scrollTo(0, savedY));
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    const overlay = this.querySelector('#CartDrawer-Overlay');
    setTimeout(() => {
      overlay.addEventListener('click', (evt) => {
        if (evt.target === overlay) {
          this.close();
        }
      });
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


const DATAJET_TASK_ID = window.DATAJET_TASK_ID;

async function fetchLoyaltyPoints(email) {
  if (!email) return null;
  try {
    const res  = await fetch(`/apps/datajet/task/${DATAJET_TASK_ID}`, {
      method : 'POST',
      headers: { 'Content-Type': 'application/json' },
      body   : JSON.stringify({ email })
    });
    const json = await res.json();
    return json.status === 'ok' ? json.data?.body?.points_balance : null;
  } catch (err) {
    console.error('[Loyalty] fetch error', err);
    return null;
  }
}

function showLoyaltyPoints(points, containerSelector, labelSelector) {
  if (points === null) return;

  const box   = document.querySelector(containerSelector);
  const label = document.querySelector(labelSelector);

  if (box && label) {
    label.textContent = `${points} Pts`;
    box.classList.remove('hidden');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const email = document.querySelector('[data-customer-email]')?.dataset.customerEmail;
  const loyaltyBoxExists = document.querySelector('.cart__loyalty');
  if (email && loyaltyBoxExists) {
    fetchLoyaltyPoints(email)
        .then((points) => {
          showLoyaltyPoints(points, '.cart__loyalty', '.cart__loyalty-points');
        });
  }
});